import { useEffect, useState } from "react";
import { fetchSettings } from "./smsApi";

// Tiny hook so Compose/Blast/MessageThread can share the same canned-message
// fetch. Intentionally no cache — settings change infrequently and any stale
// state clears on tab switch (Compose) or re-mount.
export function useCannedMessages() {
  const [messages, setMessages] = useState<string[]>([]);

  useEffect(() => {
    let alive = true;
    fetchSettings()
      .then((s) => {
        if (alive && s.canned_messages) setMessages(s.canned_messages);
      })
      .catch(() => {
        // Non-critical — quick replies just won't show.
      });
    return () => {
      alive = false;
    };
  }, []);

  return messages;
}
